import GuestInterviews from './GuestInterviews';

export default GuestInterviews;
